<template>
  <div class="reports">
    <Modal :x="currentModalPage === 1" v-show="$store.state.showModal">
      <span slot="header">
        {{ $t("message.selectVehicles") }}
      </span>
      <div slot="body">
        <div
          class="gradient-divider short"
          v-show="currentModalPage === 2"
        ></div>
        <div class="select-vehicles-container">
          <div class="tabs">
            <div class="tab compatible">{{ $t("message.compatible") }}</div>
            <div class="tab">{{ $t("message.selected") }}</div>
          </div>
          <div class="search-and-upload-container">
            <label class="search-container" for="search">
              <div class="input">
                <input
                  required
                  type="text"
                  id="search"
                  v-model="search"
                  placeholder="Label, Make and Model, VIN"
                />
                <svg
                  id="gml:icon1/field-search"
                  class="search icon"
                  viewBox="0 0 24 24"
                  fill="var(--grey)"
                >
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                  ></path>
                </svg>
              </div>
            </label>

            <div class="upload-container">
              <button class="upload-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="upside-down"
                >
                  <path
                    fill="var(--blue)"
                    fill-rule="evenodd"
                    d="M8.5 9.778l2.462-2.624a.475.475 0 0 1 .692 0 .539.539 0 0 1 0 .737l-2.926 3.117a1 1 0 0 1-1.458 0L4.346 7.892a.54.54 0 0 1 .022-.76.475.475 0 0 1 .671.022L7.5 9.776V3.5a.5.5 0 0 1 1 0v6.278zM2 13.5a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                  />
                </svg>
                <span class="hide-on-mobile">
                  {{ $t("message.uploadCsv") }}</span
                >
              </button>
            </div>
          </div>
          <div class="table-container">
            <div class="table-top-bar">
              <span>3 {{ $t("message.found") }}</span>
              <div class="selection">
                <div class="select-all">{{ $t("message.selectAll") }}</div>
                <div class="clear-all">{{ $t("message.clearAll") }}</div>
              </div>
            </div>
            <VehicleSelectionTable
              :data="[
                dataset.vehicles[0],
                dataset.vehicles[1],
                dataset.vehicles[2],
              ]"
            />
          </div>
        </div>
        <div class="buttons">
          <button
            :disabled="currentModalPage === 1"
            @click="$store.commit('toggleModal')"
            :class="`pg-${currentModalPage} cancel`"
          >
            {{ currentModalPage === 1 ? "Back" : "Cancel" }}
          </button>
          <button
            @click="$store.commit('toggleModal')"
            :class="`pg-${currentModalPage}`"
          >
            {{ $t("message.saveSelection") }}
          </button>
        </div>
      </div>
    </Modal>
    <h1 v-if="!isMobile">{{ $t("message.reports") }}</h1>
    <div class="tabs">
      <div
        @click="currentPageNumber > 1 && currentPageNumber--"
        :class="{ tab: true, current: currentPageNumber === 1 }"
      >
        {{ $t("message.reports") }}
      </div>
      <div
        @click="currentPageNumber < 2 && currentPageNumber++"
        :class="{ tab: true, current: currentPageNumber === 2 }"
      >
        {{ $t("message.scheduledReports") }}
      </div>
    </div>
    <div class="gradient-divider" />
    <div class="report-info-wrap" v-show="currentPageNumber === 1">
      <span id="report-type-lbl" class="bold label">{{ $t("message.reportType") }}</span>
      <div
        class="dropdown"
        @click="reportTypeDropdownOpen = !reportTypeDropdownOpen"
        :class="{ open: reportTypeDropdownOpen }"
      >
        <span class="dropdown-selected-option">{{
          $t("message." + camelize(selectedReportType))
        }}</span>
        <img
          class="dropdown-arrow"
          :class="{ open: reportTypeDropdownOpen }"
          src="@/assets/arrow_down.svg?external"
        />
        <div class="dropdown-options" v-if="reportTypeDropdownOpen">
          <div class="option" @click="selectedReportType = 'Vehicles'">
            {{ $t("message.vehicles") }}
          </div>
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedReportType = 'Drivers'"
          >
            {{ $t("message.drivers") }}
          </div>
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedReportType = 'Vehicle Trip Summary'"
          >
            {{ $t("message.vehicleTripSummary") }}
          </div>
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedReportType = 'Driver Trip Summary'"
          >
            {{ $t("message.driverTripSummary") }}
          </div>
          <div
            class="option"
            @click="selectedReportType = 'Trip Events'"
          >
            {{ $t("message.tripEvents") }}
          </div>
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedReportType = 'Unassigned Trips'"
          >
            {{ $t("message.unassignedTrips") }}
          </div>
          <div
            class="option"
            @click="selectedReportType = 'Fueling and Charging'"
          >
            {{ $t("message.fuelingAndCharging") }}
          </div>
          <div
            class="option"
            @click="selectedReportType = 'Expenses'"
          >
            {{ $t("message.expenses") }}
          </div>
          <div
            class="option"
            @click="selectedReportType = 'Telemetry'"
          >
            {{ $t("message.telemetry") }}
          </div>
        </div>
      </div>
      <div class="info">
        <span v-if="selectedReportType == 'Unassigned Trips'">{{
          $t("message.allTripReport")
        }}</span>
        <span v-if="selectedReportType == 'Drivers'">{{
          $t("message.allDriverReport")
        }}</span>
        <span v-if="selectedReportType == 'Vehicles'">{{
          $t("message.allVehicleReport")
        }}</span>
        <span v-if="selectedReportType == 'Driver Trip Summary'">
          {{ $t("message.allTripReportByDriver") }}</span
        >
        <span v-if="selectedReportType == 'Vehicle Trip Summary'">{{
          $t("message.allTripReportByVehicle")
        }}</span>
        <span v-if="selectedReportType == 'Trip Events'">
          {{ $t("message.reportTripEvents") }}
        </span>
        <span v-if="selectedReportType == 'Fueling and Charging'">
          {{ $t("message.reportFuelingAndCharging") }}
        </span>
        <span v-if="selectedReportType == 'Expenses'">
          {{ $t("message.reportExpenses") }}
        </span>
        <span v-if="selectedReportType == 'Telemetry'">
          {{ $t("message.reportTelemetry") }}
        </span>
      </div>
      <span v-if="!$store.state.inDealerMode" class="bold label">{{
        $store.state.inDealerMode ? $t("message.geofence") : $t("message.fleet")
      }}</span>
      <div v-if="!$store.state.inDealerMode" class="radio-grid">
        <svg
          id="gml:icon/radiobutton"
          @click="fleetFilter = 1"
          viewBox="0 0 24 24"
        >
          <path
            v-if="fleetFilter !== 1"
            fill="var(--grey)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
          />
          <path
            v-else
            fill="var(--blue)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>
        <span>{{
          $store.state.inDealerMode
            ? $t("message.geofence")
            : $t("message.allFleets")
        }}</span>
        <svg
          id="gml:icon/radiobutton"
          @click="fleetFilter = 2"
          viewBox="0 0 24 24"
        >
          <path
            v-if="fleetFilter !== 2"
            fill="var(--grey)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
          />
          <path
            v-else
            fill="var(--blue)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>
        <span
          >{{ $t("message.select") }}
          {{
            $store.state.inDealerMode
              ? $t("message.geofence")
              : $t("message.fleet")
          }}</span
        >
      </div>
      <span v-if="fleetFilter === 2"
        >{{ $t("message.select") }}
        {{
          $store.state.inDealerMode
            ? $t("message.geofence")
            : $t("message.fleet")
        }}
        *</span
      >
      <div
        class="dropdown"
        v-if="fleetFilter === 2"
        @click="fleetDropdownOpen = !fleetDropdownOpen"
        :class="{ open: fleetDropdownOpen }"
      >
        <span class="dropdown-selected-option">{{ selectedFleet }}</span>
        <img
          class="dropdown-arrow"
          :class="{ open: fleetDropdownOpen }"
          src="@/assets/arrow_down.svg?external"
        />
        <div class="dropdown-options" v-if="fleetDropdownOpen">
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedFleet = 'Fleet One'"
          >
            {{ $t("message.fleetOne") }}
          </div>
          <div
            v-if="!$store.state.inDealerMode"
            class="option"
            @click="selectedFleet = 'Fleet Two'"
          >
            {{ $t("message.fleetTwo") }}
          </div>
          <div
            v-if="$store.state.inDealerMode"
            class="option"
            @click="selectedFleet = 'Fleet Two'"
          >
            {{ $t("message.fleetOne") }}
          </div>
          <div
            v-if="$store.state.inDealerMode"
            class="option"
            @click="selectedFleet = 'Fleet Two'"
          >
            {{ $t("message.fleetTwo") }}
          </div>
          <div
            v-if="$store.state.inDealerMode"
            class="option"
            @click="selectedFleet = 'Fleet Two'"
          >
            {{ $t("message.fleetTwo") }}
          </div>
        </div>
      </div>
      <span class="bold label vehicle-label">
        {{ $t("message.vehicles") }}</span
      >
      <div class="select-vehicles radio-grid">
        <svg
          id="gml:icon/radiobutton"
          @click="vehicleFilter = 1"
          viewBox="0 0 24 24"
        >
          <path
            v-if="vehicleFilter !== 1"
            fill="var(--grey)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
          />
          <path
            v-else
            fill="var(--blue)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>

        <span>{{ $t("message.allVehicles") }}</span>
        <svg
          id="gml:icon/radiobutton"
          @click="vehicleFilter = 2"
          viewBox="0 0 24 24"
        >
          <path
            v-if="vehicleFilter !== 2"
            fill="var(--grey)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
          />
          <path
            v-else
            fill="var(--blue)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>
        <span>{{ $t("message.selectVehicles") }}</span>
        <svg
          id="gml:icon/radiobutton"
          @click="vehicleFilter = 3"
          viewBox="0 0 24 24"
        >
          <path
            v-if="vehicleFilter !== 3"
            fill="var(--grey)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
          />
          <path
            v-else
            fill="var(--blue)"
            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>
        <span>{{ $t("message.byTags") }}</span>
      </div>
      <span v-if="vehicleFilter === 2"
        >{{ $t("message.selectVehicles") }} *</span
      >
      <div
        class="dropdown"
        v-if="vehicleFilter === 2"
        @click="vehicleDropdownOpen = !vehicleDropdownOpen"
        :class="{ open: vehicleDropdownOpen }"
      >
        <div class="dropdown-selected-option flex">
          <div
            class="multichoose-item"
            v-for="(vehicleName, index) of selectedVehicles"
            :key="'H' + index"
          >
            {{ vehicleName }}
            <svg
              id="gml:icon/tag-remove"
              @click="
                removeItemFromMultichoose(vehicleName, 'selectedVehicles')
              "
              viewBox="0 0 24 24"
            >
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
              />
            </svg>
          </div>
        </div>
        <svg
          class="dropdown-search"
          id="gml:icon/field-search"
          viewBox="0 0 24 24"
          @click="$store.commit('toggleModal')"
        >
          <path
            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
          />
        </svg>
        <div class="dropdown-options" v-if="false">
          <div
            class="option"
            v-for="(vehicle, index) of dataset.vehicles"
            @click="
              addItemToMultichoose(vehicle['Vehicle Label'], 'selectedVehicles')
            "
            :key="'G' + index"
          >
            {{ vehicle["Vehicle Label"] }}
          </div>
        </div>
      </div>
      <span v-if="vehicleFilter === 3"> {{ $t("message.selectTags") }} *</span>
      <div
        class="dropdown"
        v-if="vehicleFilter === 3"
        @click="vehicleDropdownOpen = !vehicleDropdownOpen"
        :class="{ open: vehicleDropdownOpen }"
      >
        <div class="dropdown-selected-option flex">
          <div
            class="multichoose-item"
            v-for="(vehicleName, index) of selectedVehicles"
            :key="'H' + index"
          >
            {{ vehicleName }}
            <svg
              id="gml:icon/tag-remove"
              @click="
                removeItemFromMultichoose(vehicleName, 'selectedVehicles')
              "
              viewBox="0 0 24 24"
            >
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
              />
            </svg>
          </div>
        </div>
        <svg
          class="dropdown-search"
          id="gml:icon/field-search"
          viewBox="0 0 24 24"
        >
          <path
            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
          />
        </svg>
        <div class="dropdown-options" v-if="vehicleDropdownOpen">
          <div
            class="option"
            v-for="(vehicle, index) of dataset.vehicles"
            @click="
              addItemToMultichoose(vehicle['Vehicle Label'], 'selectedVehicles')
            "
            :key="'G' + index"
          >
            {{ vehicle["Vehicle Label"] }}
          </div>
        </div>
      </div>
      <!-- <span class="bold label date-label" v-if="!$store.state.inDealerMode">{{
        $t("message.dateRange")
      }}</span>
      <span v-if="!$store.state.inDealerMode">
        {{ $t("message.selectRange") }} *</span
      >
      <div
        v-if="!$store.state.inDealerMode"
        class="dropdown"
        @click="dateDropdownOpen = !dateDropdownOpen"
        :class="{ open: dateDropdownOpen }"
      >
        <span class="dropdown-selected-option">{{ selectedRange }}</span>
        <img
          class="dropdown-arrow"
          :class="{ open: fleetDropdownOpen }"
          src="@/assets/arrow_down.svg?external"
        />
        <div class="dropdown-options" v-if="dateDropdownOpen">
          <div
            class="option"
            @click="
              selectedRange = `${$t('message.last')} 7 ${$t('message.days')}`
            "
          >
            {{ $t("message.last") }} 7 {{ $t("message.days") }}
          </div>
          <div
            class="option"
            @click="
              selectedRange = `${$t('message.last')} 30 ${$t('message.days')}`
            "
          >
            {{ $t("message.last") }} 30 {{ $t("message.days") }}
          </div>
        </div>
      </div> -->
      <div
        class="buttons"
        :style="{ 'margin-top': $store.state.inDealerMode ? '30px' : '' }"
      >
        <button disabled>
          {{ $t("message.sendOnSchedule") }}
        </button>
        <button
          @click="
            showReport = true;
            checkChallenge();
          "
          class="download-btn"
        >
          {{ $t("message.download") }}
        </button>
      </div>

      <div class="report-wrap" v-if="showReport">
        <img
          @click="showReport = false"
          class="report-close"
          src="@/assets/clear.svg?external"
        />
        <img
          v-if="$store.state.inDealerMode"
          class="report"
          src="@/assets/report_dealer.png"
        />
        <img v-else class="report" src="@/assets/report.png" />
      </div>
    </div>
    <div class="scheduled-reports" v-show="currentPageNumber === 2">
      <ScheduledReports v-if="true" />
      <div class="no-results" v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="400"
          height="300"
          viewBox="0 0 400 300"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#C1C8D6" fill-rule="nonzero">
              <path
                d="M0 0L107.189 0 107.189 4 0 4zM330.23 0L330.23 4 202 4 202.247 0z"
                transform="translate(35 56) translate(0 170)"
              />
            </g>
            <path
              fill="#F2F3F4"
              fill-rule="nonzero"
              d="M330 169.82c-20-19-24.25-28.4-20.41-68.04 3.84-39.64-10.08-82.062-60.08-74.852C157.06 40.268 127.82-25.61 52 13.06-19.77 49.67 41 133 0 169.82h330z"
              transform="translate(35 56)"
            />
            <g>
              <path
                fill="#C1C8D6"
                d="M241.404 68c2.551 0 4.868 1.4 6.044 3.657l.046.17 7.296 15.007.023-.013.19.341c1.18 2.121 2.845 4.288 6.239 4.288h5.447v3.65h-5.447c-.544 0-1.058-.036-1.546-.104l2.286 3.133c.088.124.158.254.212.391.445 1.09.67 2.244.668 3.426v14.05c0 .128-.004.256-.011.383l.005.086v16.232c0 2.285-1.799 4.16-4.058 4.295l-.263.008h-10.037c-2.295 0-4.177-1.79-4.313-4.042l-.008-.261v-9.918h-43.012l.001 9.896c.006 1.136-.453 2.25-1.258 3.057-.806.806-1.924 1.268-3.063 1.268h-10.037c-2.383 0-4.32-1.93-4.32-4.303v-16.232c0-.073.004-.145.012-.215l-.006-.254v-14.05c-.001-1.18.223-2.333.663-3.429.062-.14.132-.264.212-.38L185.655 95c-.48.065-.985.1-1.518.1h-5.448v-3.616h5.448c3.259 0 4.911-1.986 6.079-3.997.068-.192.151-.38.246-.564l7.407-15.178C199.085 69.4 201.402 68 203.955 68h37.449zm-55.289 53.988v10.709c.004.375.315.686.696.69h10.034c.377-.004.69-.315.691-.693v-9.915h-8.23c-1.152 0-2.239-.286-3.19-.79zm73.112.006c-.974.51-2.067.786-3.176.786l-8.246-.001v9.896c.003.335.25.618.572.679l.124.012h10.034c.335-.003.62-.249.68-.57l.01-.124.002-10.678zm-5.752-27.107h-61.644c-1.016 0-1.98.489-2.576 1.31l-2.81 3.876c-.175.487-.28.99-.316 1.502l-.014.496 12.294.002v4.736c0 1.814-.71 3.518-1.997 4.8-1.287 1.28-2.997 1.984-4.815 1.984l-5.482-.001v2.404c0 1.746 1.43 3.17 3.185 3.17h66.73c1.755 0 3.183-1.424 3.183-3.17v-2.404l-5.526.001c-3.755 0-6.812-3.044-6.812-6.784v-4.736l12.338-.002v-.125c0-.646-.113-1.279-.335-1.887l-2.825-3.86c-.598-.823-1.561-1.312-2.578-1.312zm-10.413 7.213l-4.928 9.803c-1.157 2.321-3.494 3.766-6.1 3.766h-18.811c-2.604 0-4.943-1.445-6.1-3.768l-4.928-9.8h40.867zm-5.885 3.614H208.08l2.296 4.585c.545 1.09 1.652 1.72 2.859 1.756h18.789c1.214 0 2.305-.67 2.85-1.756l2.303-4.585zm-51.062-.029v4.293l5.475.001c1.756 0 3.184-1.422 3.184-3.17v-1.122l-8.66-.002zm73.098 0l-8.737.002v1.122c0 1.748 1.428 3.17 3.184 3.17l5.553-.001v-4.293zm-17.562-34.1l-10.102.001-1.917 3.825H215.61l-1.917-3.825h-9.724c-1.092-.028-2.122.553-2.706 1.473l-.082.186-7.46 15.278c-.034.063-.064.127-.089.193l.054.032-.133.23c-.096.443-.02.91.228 1.3.383.623 1.05 1.026 1.803.972h26.188c.708-5.765 5.78-10.25 11.915-10.25 6.135 0 11.21 4.485 11.917 10.25h4.213c.736-.022 1.431-.346 1.813-.968.24-.38.32-.832.238-1.26l-.039-.063-.187-.334.078-.046-.108-.146-7.39-15.21c-.518-.945-1.49-1.597-2.572-1.638z"
                transform="translate(35 56) translate(25 37)"
              />
              <g>
                <path
                  fill="#C1C8D6"
                  fill-rule="nonzero"
                  d="M94.25 100H3l-3-4h87.8L76.74 73.86c-2.587-5.206-7.907-8.49-13.72-8.47h-5.48v-4h5.45c7.333-.027 14.043 4.12 17.3 10.69L94.25 100zM5.7 69.42L3 66.48c3.566-3.279 8.236-5.096 13.08-5.09h5.33v4h-5.33c-3.843-.006-7.548 1.432-10.38 4.03zM39.54 53.19c-12.68-.033-22.94-10.32-22.94-23V23C16.566 10.404 26.695.137 39.29 0h.46c11.735.139 21.483 9.09 22.62 20.77.078.724.115 1.452.11 2.18v7.28c-.022 12.664-10.276 22.927-22.94 22.96zM39.74 4h-.42c-10.402.115-18.764 8.598-18.73 19v7.28c-.158 6.872 3.418 13.291 9.345 16.773 5.926 3.483 13.274 3.483 19.2 0 5.927-3.482 9.503-9.9 9.345-16.773V23c.005-.588-.025-1.176-.09-1.76-.564-5.832-3.775-11.081-8.71-14.24-2.968-1.916-6.417-2.956-9.95-3h.01z"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
                <path
                  fill="#C1C8D6"
                  fill-rule="nonzero"
                  d="M60.48 25.92h-.22c-9 0-17-4.51-20.73-11.11-3.73 6.6-11.74 11.11-20.73 11.11h-.21l-2-2v-.81h2v-1.19h.21c9.38 0 17.45-5.7 18.76-13.26h3.98c1.31 7.56 9.38 13.26 18.76 13.26h.22v1.19h2v.81l-2.04 2zM48.36 60.66c-1.14-1.862-1.735-4.007-1.72-6.19-.047-3.257 1.3-6.379 3.7-8.58l2.66 3c-1.55 1.436-2.408 3.468-2.36 5.58-.012 1.44.376 2.856 1.12 4.09l-3.4 2.1zM30.78 60.56l-3.44-2.06c.714-1.211 1.088-2.594 1.08-4 .048-2.112-.81-4.144-2.36-5.58l2.66-3c2.4 2.201 3.747 5.323 3.7 8.58 0 2.13-.565 4.221-1.64 6.06z"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
                <path
                  fill="#C1C8D6"
                  fill-rule="nonzero"
                  d="M33.54 81c-.617 0-1.2-.283-1.58-.77L19.83 64.62c-.37-.472-.51-1.085-.38-1.67.146-.59.545-1.084 1.09-1.35l7.65-3.86c.802-.404 1.776-.225 2.38.44l10.49 11.47c.648.71.698 1.782.12 2.55l-6 8c-.373.498-.958.794-1.58.8h-.06zm-9.06-16.92l9 11.62 3.44-4.57L28.6 62l-4.12 2.08z"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
                <path
                  fill="#C1C8D6"
                  fill-rule="nonzero"
                  d="M45.41 81c-.622-.006-1.207-.302-1.58-.8l-6-8c-.578-.768-.528-1.84.12-2.55l10.48-11.47c.604-.665 1.578-.844 2.38-.44l7.65 3.86c.53.27.912.76 1.044 1.34.131.58-.002 1.188-.364 1.66L47 80.21c-.378.497-.966.79-1.59.79zM42 71.13l3.43 4.57 9-11.62L50.34 62 42 71.13zM31.54 99c-.66.001-1.278-.323-1.652-.867-.374-.544-.456-1.237-.218-1.853l4.65-12.09L31.83 80c-.489-.937-.164-2.093.741-2.638.906-.546 2.08-.292 2.679.578l3 5c.32.527.38 1.173.16 1.75l-5 13c-.288.785-1.034 1.307-1.87 1.31z"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
                <path
                  fill="#C1C8D6"
                  fill-rule="nonzero"
                  d="M47.54 99c-.828.002-1.572-.507-1.87-1.28l-5-13c-.22-.577-.16-1.223.16-1.75l3-5c.344-.66 1.026-1.074 1.77-1.075.743-.001 1.426.41 1.773 1.068.346.658.3 1.455-.123 2.067l-2.49 4.16 4.65 12.09c.238.616.156 1.31-.218 1.853-.374.544-.992.868-1.652.867z"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
                <path
                  stroke="#C1C8D6"
                  stroke-width="4"
                  d="M33.89 36c.853 2.387 3.115 3.98 5.65 3.98s4.797-1.593 5.65-3.98"
                  transform="translate(35 56) translate(25 37) matrix(-1 0 0 1 95 37)"
                />
              </g>
              <g stroke="#0C3454" stroke-width="4">
                <path
                  fill="#F2F3F4"
                  d="M105 2H13.027v3.729c0 .828-.335 1.578-.878 2.12-.543.544-1.293.88-2.122.88H2v146h80.845L115 118.366V8.646l-7.125-.297c-.804-.033-1.522-.38-2.04-.92S105 6.156 105 5.352V2z"
                  transform="translate(35 56) translate(25 37) translate(82)"
                />
                <path
                  d="M105 1.729H13v12c0 4.418 1.79 8.418 4.686 11.313C20.582 27.938 24.582 29.73 29 29.73h60c4.418 0 8.418-1.791 11.314-4.687C103.209 22.147 105 18.147 105 13.73v-12zM113.536 119H96c-3.59 0-6.84 1.455-9.192 3.808C84.455 125.16 83 128.41 83 132l.418 21.416L113.536 119z"
                  transform="translate(35 56) translate(25 37) translate(82)"
                />
              </g>
            </g>
            <path
              stroke="#0C3454"
              stroke-width="4"
              d="M137 83.5L175 83.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#05B5E4"
              stroke-width="4"
              d="M187 83.5L198 83.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#0C3454"
              stroke-width="4"
              d="M137 98.5L175 98.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#05B5E4"
              stroke-width="4"
              d="M187 98.5L198 98.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#0C3454"
              stroke-width="4"
              d="M137 113.5L175 113.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#05B5E4"
              stroke-width="4"
              d="M187 113.5L198 113.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#0C3454"
              stroke-width="4"
              d="M137 128.5L175 128.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#05B5E4"
              stroke-width="4"
              d="M187 128.5L198 128.5"
              transform="translate(35 56)"
            />
            <path
              stroke="#0C3454"
              stroke-width="4"
              d="M137 142.5L198 142.5M137 155.5L179.764 155.5"
              transform="translate(35 56)"
            />
          </g>
        </svg>
        <span> {{ $t("message.noResultsWereFound") }}</span>
      </div>
    </div>
    <GuidedTourWaypoint :id="11" bottomCircle />
  </div>
</template>

<script>
import ScheduledReports from "@/components/demo/ScheduledReports.vue";
import Modal from "@/components/demo/Modal.vue";
import VehicleSelectionTable from "@/components/demo/VehicleSelectionTable.vue";
import GuidedTourWaypoint from "@/components/demo/GuidedTourWaypoint.vue";
import { camelize } from "../../utils/camelize.js";

export default {
  props: {
    dataset: Object,
    isMobile: Boolean,
    activeChallenge: String,
    challenges: Array,
    timeLeft: Number,
    numIncomplete: Number,
    multiplier: Number,
  },
  components: {
    Modal,
    VehicleSelectionTable,
    ScheduledReports,
    GuidedTourWaypoint,
  },
  data() {
    return {
      search: "",
      currentModalPage: 1,
      fleetFilter: 1,
      vehicleFilter: 1,
      reportTypeDropdownOpen: false,
      fleetDropdownOpen: false,
      vehicleDropdownOpen: false,
      dateDropdownOpen: false,
      selectedReportType: "Vehicles",
      selectedFleet: this.$t("message.fleetOne"),
      selectedVehicles: [],
      selectedRange: this.$t("message.last7Days"),
      showReport: false,
      bingo: false,
      currentPageNumber: 1,
      camelize: camelize,
    };
  },
  methods: {
    checkChallenge() {
      if (this.activeChallenge === "easy-to-prepare") {
        setTimeout(() => {
          this.bingo = true;
          this.$emit("challengeComplete", 11);
          this.$emit("pauseTimer");
          this.showReport = false;
        }, 1000);
      }
    },
    addItemToMultichoose(item, multichoose) {
      if (this[multichoose].indexOf(item) === -1) {
        this[multichoose].push(item);
      }
    },
    removeItemFromMultichoose(item, multichoose) {
      const index = this[multichoose].indexOf(item);
      if (index !== -1) {
        this[multichoose].splice(index, 1);
      }
    },
  },
  watch: {
    timeLeft: function () {
      if (this.timeLeft <= 0) {
        this.bingo = false;
      }
    },
    numIncomplete: function () {
      if (this.numIncomplete === 0) {
        this.$emit("noMoreChallenges");
      }
    },
  },
};
</script>

<style scoped lang="scss">
*:not(h1) {
  font-size: 15px;
}
.reports {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.report-info-wrap {
  width: 90%;
  max-width: 800px;
  display: flex;
  flex-direction: column;

  .label:first-child {
    padding-bottom: 20px;
  }
  .vehicle-label,
  .date-label {
    margin-top: 30px;
  }
  .info {
    border-bottom: 1px solid var(--light-grey);
    padding-bottom: 10px;
    margin-bottom: 5px;
  }
}
.dropdown {
  height: 30px;
  width: 40%;
  margin-bottom: 24px;
  background-color: var(--white);
  font-family: ProximaNova;
  padding-left: 12px;
  border: 1px solid var(--light-grey-2);
  position: relative;
  z-index: 1;
  transition: transform 0.5s ease;
  cursor: pointer;
  @media screen and (max-width: 1112px) {
    width: 50%;
  }
}
.dropdown.open {
  border: 1px solid var(--blue);
  z-index: 5;
}
.dropdown-selected-option {
  position: absolute;
  top: 3px;
  left: 12px;
  transition: transform 0.5s ease;
}
.dropdown-arrow {
  position: absolute;
  top: 3px;
  right: 3px;
  transition: transform 0.5s ease;
}
.dropdown-arrow.open {
  transform: rotate(180deg);
}
.dropdown-options {
  position: absolute;
  top: 31px;
  background-color: var(--white);
  margin-left: -12px;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  display: grid;
  grid-template-rows: repeat(auto-fill, 30px);
}
.dropdown-options .option {
  height: 30px;
  color: var(--dark-grey);
  display: flex;
  align-items: center;
  padding-left: 12px;
  cursor: pointer;
}
span {
  color: var(--dark-grey);
}

svg {
  cursor: pointer;
  width: 18px;
  height: 18px;
}
.radio-grid {
  display: grid;
  align-items: center;
  margin-top: 2px;
  margin-bottom: 8px;
  grid-template-columns: 18px 85px 18px 110px 18px 52px;
  grid-gap: 8px;
}
.radio-grid span,
.label {
  color: unset;
}
.multichoose-item {
  background-color: var(--light-grey-2);
  padding: 2px 8px;
  margin-right: 6px;
  margin-top: -1px;
  font-size: 13px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.dropdown-search {
  position: absolute;
  top: 3px;
  right: 3px;
  fill: var(--dark-grey);
  width: 24px;
  height: 24px;
}
.multichoose-item svg {
  width: 13px;
  height: 13px;
  margin-left: 4px;
  cursor: pointer;
}
.report-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  z-index: 100;
}
.report-close {
  width: 32px;
  height: 32px;
  margin: 20px;
}
.report {
  width: 100%;
}
.tabs {
  display: flex;
  font-weight: bold;
  padding-bottom: 20px;
  .tab {
    padding: 5px 10px;
  }
  .tab:first-child {
    margin-right: 5px;
  }
  .tab.current {
    color: var(--light-blue);
    border-bottom: 3px solid var(--light-blue);
  }
}
.no-results {
  width: 400px;
  height: 300px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  svg {
    width: 400px;
    height: 300px;
  }
  span {
    text-align: center;
    margin: 0 auto;
    font-size: 15px;
    font-family: ProximaNova;
  }
}
.buttons {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--light-grey);
  padding-top: 30px;
  button {
    border: 0;
    margin-top: 40px;
    align-self: center;
    width: 20%;
    height: 30px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--blue);
    color: var(--white);
    border-radius: 4px;
    font-weight: 600;
    min-width: fit-content;
    cursor: pointer;

    &:first-child:disabled {
      background: #fff;
      border: 1px solid var(--light-grey);
      color: var(--light-grey);
    }
  }
}
.scheduled-reports {
  width: 90%;
}

.select-vehicles-container {
  width: 90%;
  padding: 0 5%;
  .tabs {
    display: flex;
    width: 100%;
    margin-bottom: 25px;
    .tab {
      width: 50%;
      text-align: center;
      font-weight: bold;
      color: var(--blue);
    }
    .compatible {
      border-bottom: 1px solid var(--blue);
    }
  }
  .selection {
    width: 20%;
  }
  .search-and-upload-container {
    display: flex;
    .search-container {
      width: 30%;
      border-right: 1px solid var(--light-grey);
      margin-right: 10px;
      padding-right: 20px;
      display: flex;
      align-items: center;
      .input {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        border: 1px solid var(--light-grey);
        padding: 0 5px;
        border-radius: 0.25rem;
        max-height: 25px;
        input {
          border: 0;
          width: 100%;
        }
      }
      .icon {
        width: 24px;
        height: 24px;
      }
      @media screen and (max-width: 1112px) {
        width: 80%;
      }
    }

    button {
      max-height: 35px;
      min-height: 25px;
      font-weight: bold;
      border-radius: 0.25rem;
      width: fit-content;
      color: var(--blue);
      background: #fff;
      border: 1px solid var(--light-grey);
      display: flex;
      align-items: center;
      svg {
        margin-right: 3px;
      }
    }
  }
}
.table-container {
  .table-top-bar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-weight: bold;
    color: var(--light-grey);
    margin-top: 20px;
    .selection {
      color: var(--blue);
      display: flex;
      justify-content: flex-end;
      width: 30%;
      @media screen and (max-width: 1112px) {
        width: 50%;
      }
      .select-all {
        border-right: 1px solid var(--light-grey);
        padding-right: 5px;
        margin-right: 5px;
      }

      @media screen and (max-width: 1112px) {
      }
    }
  }
}

.buttons {
  border-top: 1px solid var(--grey);
  width: 80%;
  margin: 4px auto;
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
  button {
    font-weight: bold;
    border: 0;
    border-radius: 0.25rem;

    &.pg-1 {
      color: var(--blue);
      background: #fff;
      margin-right: 10px;
    }
    &.pg-2 {
      background: var(--blue);
      color: #fff;
    }
    &.pg-1:disabled {
      color: var(--grey);
      background: #fff;
    }
    &.pg-2:disabled {
      border: 1px solid var(--grey);
    }
    &.cancel {
      width: 10%;
      color: var(--blue);
      margin-right: 10px;
      background: #fff;
      border: 1px solid var(--grey);
    }
  }
}

.upside-down {
  transform: rotate(180deg);
}
</style>
